import store from '../../redux/store/store'
import { hide, show } from "../../redux/slice/SettingSlice";
import axios from "axios";
import { errorToast, successToast } from '../../helper/FormHelper'
import { getToken } from "../helper/SessionHelper";
import {
    BaseURL,
    CategoryListURL,
    CategoryCreateURL,
    CategoryUpdateURL,
    CategoryShowURL,
    CategoryDeleteURL,
    MeasurementTypeListRL
} from "../helper/Config";

import { onChangeCategoryFormInput, resetCategoryFormValue, setCategoryList, setCategoryTypeList } from '../../redux/slice/admin/CategorySlice';
const AxiosHeader = {
    headers: {
        "Authorization": `Bearer ${getToken()}`
    }
}


export async function CategoryCreateApiService(postBody, id) {
    try {
        store.dispatch(show())
        let URL = BaseURL + CategoryCreateURL
        let method = 'post';
        if (id !== 0) {
            URL = BaseURL + CategoryUpdateURL + "/" + id;
            method = "put";
        }
        const result = await axios({
            method,
            url: URL,
            data: postBody,
            headers: AxiosHeader.headers
        });
        store.dispatch(hide())
        if (result.data.status === true) {
            successToast("Request Successful");
            store.dispatch(resetCategoryFormValue())
            return true;
        }
        if (result.data.status === false) {
            errorToast(result.data.message)
            return false;
        }
    } catch (e) {
        errorToast("Something Went Wrong")
        store.dispatch(hide())
        return false
    }
}
export async function GetMeasurementTypeList() {
    try {
        store.dispatch(show())
        let URL = BaseURL + MeasurementTypeListRL;
        const result = await axios.get(URL, AxiosHeader)
        store.dispatch(hide())
        if (result.data.status === true) {
            store.dispatch(setCategoryTypeList(result.data.data))
        }
        if (result.data.status === false) {
            errorToast(result.data.message)
        }
    } catch (e) {
        errorToast("Something Went Wrong")
        store.dispatch(hide())
    }
}
export async function GetCategoryList() {
    try {
        store.dispatch(show())
        let URL = BaseURL + CategoryListURL;
        const result = await axios.get(URL, AxiosHeader)
        store.dispatch(hide())
        if (result.data.status === true) {
            store.dispatch(setCategoryList(result.data.data))
        }
        if (result.data.status === false) {
            errorToast(result.data.message)
        }
    } catch (e) {
        errorToast("Something Went Wrong")
        store.dispatch(hide())
    }
}
export async function DeleteCategory(id) {
    try {
        store.dispatch(show())
        let URL = BaseURL + CategoryDeleteURL + "/" + id;
        const result = await axios.delete(URL, AxiosHeader)
        store.dispatch(hide())
        if (result.data.status === true) {
            successToast(result.data.message)
            return true
        }
        if (result.data.status === false) {
            errorToast(result.data.message)
        }
    } catch (e) {
        errorToast("Something Went Wrong")
        store.dispatch(hide())
    }
}

export async function FillCategoryFormRequest(id) {
    try {
        store.dispatch(show())
        let URL = BaseURL + CategoryShowURL + "/" + id;
        const result = await axios.get(URL, AxiosHeader)
        store.dispatch(hide())
        if (result.data.status === true) {
            let formValue = result.data.data
            store.dispatch(onChangeCategoryFormInput({ name: "measurement_type_id", value: formValue.measurement_type_id }));
            store.dispatch(onChangeCategoryFormInput({ name: "manage_subcategory", value: formValue.manage_subcategory }));
            store.dispatch(onChangeCategoryFormInput({ name: "name", value: formValue.name }));
            return true;
        } else {
            errorToast("Request Fail ! Try Again")
            return false;
        }
    } catch (e) {
        errorToast("Something Went Wrong")
        store.dispatch(hide())
        return false
    }
}